import { Avatar, DialogActions, DialogContent, LinearProgress } from '@material-ui/core';
import { Picker } from '@sensenet/pickers-react';
import React, { useMemo } from 'react';
import { renderIconDefault } from "../icon.js";
const createTypeFilterString = allowedTypes => {
  let filterString = "isOf('Folder')";
  allowedTypes.forEach(typeName => {
    if (typeName !== 'Folder') {
      filterString += ` or isOf('${typeName}')`;
    }
  });
  return filterString;
};

/**
 * Represents a reference picker component
 */
export const ReferencePicker = props => {
  const pickerItemOptions = useMemo(() => ({
    select: ['DisplayName', 'Path', 'Id', 'Children/IsFolder', 'IsFolder', 'Avatar', 'Icon'],
    expand: ['Children'],
    filter: props.fieldSettings.AllowedTypes ? createTypeFilterString(props.fieldSettings.AllowedTypes) : "isOf('GenericContent')",
    metadata: 'no',
    orderby: 'DisplayName'
  }), [props.fieldSettings.AllowedTypes]);
  const iconName = isFolder => {
    if (isFolder == null) {
      return 'arrow_upward';
    }
    return isFolder ? 'folder' : 'insert_drive_file';
  };
  const renderIcon = item => {
    var _Avatar, _item$DisplayName;
    return props.repository.schemas.isContentFromType(item, 'User') ? (_Avatar = item.Avatar) !== null && _Avatar !== void 0 && _Avatar.Url ? /*#__PURE__*/React.createElement(Avatar, {
      alt: item.DisplayName,
      src: `${props.repository.configuration.repositoryUrl}${item.Avatar.Url}`
    }) : /*#__PURE__*/React.createElement(Avatar, {
      alt: item.DisplayName
    }, (_item$DisplayName = item.DisplayName) === null || _item$DisplayName === void 0 ? void 0 : _item$DisplayName.split(' ').map(namePart => namePart[0]).join('.')) : props.renderIcon ? props.renderIcon(item) : renderIconDefault(iconName(item.IsFolder));
  };
  return /*#__PURE__*/React.createElement(Picker, {
    defaultValue: props.defaultValue,
    repository: props.repository,
    currentPath: props.path,
    contextPath: props.contextPath,
    selectionRoots: props.fieldSettings.SelectionRoots,
    itemsODataOptions: pickerItemOptions,
    renderIcon: renderIcon,
    renderLoading: () => /*#__PURE__*/React.createElement(LinearProgress, null),
    allowMultiple: props.fieldSettings.AllowMultiple,
    pickerContainer: DialogContent,
    actionsContainer: DialogActions,
    handleCancel: props.handleCancel,
    handleSubmit: props.handleSubmit,
    classes: props.classes
  });
};
//# sourceMappingURL=reference-picker.js.map